import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f97289e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-area company-dashboard pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "my-profile-inner" }
const _hoisted_6 = { class: "form-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title two" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "My Profile"),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" })
], -1))
const _hoisted_8 = { class: "profile-form" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title2" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Company Information:")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-inner mb-25" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "companyname" }, "Company Name*", -1))
const _hoisted_14 = { class: "input-area" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1))
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-inner mb-25" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Industry Type*", -1))
const _hoisted_19 = { class: "input-area" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Industry Type*", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-inner mb-25" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "company" }, "Company Size*", -1))
const _hoisted_26 = { class: "input-area" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/person-2.svg",
  alt: ""
}, null, -1))
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-inner mb-25" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email*", -1))
const _hoisted_31 = { class: "input-area" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/email-2.svg",
  alt: ""
}, null, -1))
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = { class: "form-inner mb-25" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Address*", -1))
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "form-inner mb-25" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "about" }, "Comapany Detail*", -1))
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-inner mb-25" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "location" }, "Location*", -1))
const _hoisted_42 = { class: "input-area" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/map-2.svg",
  alt: ""
}, null, -1))
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-inner mb-25" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "website" }, "Website Link*", -1))
const _hoisted_47 = { class: "input-area" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/website-2.svg",
  alt: ""
}, null, -1))
const _hoisted_49 = { class: "col-md-6" }
const _hoisted_50 = { class: "form-inner mb-25" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "facebook" }, "Facebook", -1))
const _hoisted_52 = { class: "input-area" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/facebook-2.svg",
  alt: ""
}, null, -1))
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "form-inner mb-25" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "twitter" }, "X", -1))
const _hoisted_57 = { class: "input-area" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/twitter-x.svg",
  alt: "",
  width: "26"
}, null, -1))
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "form-inner mb-25" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "linkedin" }, "LinkedIn", -1))
const _hoisted_62 = { class: "input-area" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/linkedin-2.svg",
  alt: ""
}, null, -1))
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "form-inner mb-25" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pinterest" }, "Pinterest", -1))
const _hoisted_67 = { class: "input-area" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/pinterest-2.svg",
  alt: ""
}, null, -1))
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { class: "form-inner mb-25" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "dribble" }, "Instagram", -1))
const _hoisted_72 = { class: "input-area" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/instagram.svg",
  width: "16",
  alt: ""
}, null, -1))
const _hoisted_74 = { class: "col-md-6" }
const _hoisted_75 = { class: "form-inner mb-25" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "behance" }, "Behance", -1))
const _hoisted_77 = { class: "input-area" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/behance-2.svg",
  alt: ""
}, null, -1))
const _hoisted_79 = { class: "col-lg-12" }
const _hoisted_80 = { class: "company-images-area mb-50" }
const _hoisted_81 = { class: "row g-lg-4 gy-5" }
const _hoisted_82 = { class: "col-lg-6 devaider1 position-relative" }
const _hoisted_83 = { class: "company-logo-area" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Company Logo: ", -1))
const _hoisted_85 = { class: "drag-area" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Upload Logo", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "upload-btn"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" })
], -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Maximum File Upload: 2 MB", -1))
const _hoisted_89 = { class: "col-lg-6" }
const _hoisted_90 = { class: "company-cover-photo-area" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Company Cover Photo: ", -1))
const _hoisted_92 = {
  class: "drag-area",
  id: "dragArea2"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Upload Photo", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "upload-btn"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" })
], -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Maximum File Upload: 5 MB", -1))
const _hoisted_96 = {
  key: 0,
  class: "row g-lg-4 gy-5 pt-5"
}
const _hoisted_97 = { class: "col-lg-6 devaider1 position-relative text-center" }
const _hoisted_98 = ["src"]
const _hoisted_99 = ["src"]
const _hoisted_100 = { class: "col-lg-6 text-center" }
const _hoisted_101 = ["src"]
const _hoisted_102 = ["src"]
const _hoisted_103 = { class: "col-md-12" }
const _hoisted_104 = { class: "form-inner" }
const _hoisted_105 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_108 = [
  _hoisted_106,
  _hoisted_107
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_menu = _resolveComponent("company-menu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_company_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("form", _hoisted_8, [
                _hoisted_9,
                (_ctx.company)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userForm.name) = $event)),
                              type: "text",
                              id: "companyname",
                              name: "companyname",
                              placeholder: "Elite Hangstroman"
                            }, null, 512), [
                              [_vModelText, _ctx.userForm.name]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userForm.company_type_id) = $event)),
                              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeCompanyType && _ctx.changeCompanyType(...args)))
                            }, [
                              _hoisted_21,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyTypes, (companyType) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: companyType.id
                                }, _toDisplayString(companyType.name), 9, _hoisted_22))
                              }), 256))
                            ], 544), [
                              [_vModelSelect, _ctx.userForm.company_type_id]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userForm.company_size) = $event)),
                              type: "text",
                              id: "company",
                              name: "company",
                              placeholder: "40 Person"
                            }, null, 512), [
                              [_vModelText, _ctx.userForm.company_size]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userForm.email) = $event)),
                              type: "text",
                              id: "email",
                              name: "email",
                              placeholder: "info@example.com"
                            }, null, 512), [
                              [_vModelText, _ctx.userForm.email]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userForm.address) = $event)),
                            id: "description",
                            placeholder: "Address"
                          }, null, 512), [
                            [_vModelText, _ctx.userForm.address]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userForm.about) = $event)),
                            id: "description",
                            placeholder: "Company detail..."
                          }, null, 512), [
                            [_vModelText, _ctx.userForm.about]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createVNode(_component_Dropdown, {
                              modelValue: this.userForm.location_id,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.userForm.location_id) = $event)),
                              options: _ctx.states,
                              onChange: _ctx.changeState,
                              ref: "location",
                              optionLabel: "name",
                              optionValue: "id",
                              placeholder: "Select State",
                              class: "w-full md:w-14rem"
                            }, null, 8, ["modelValue", "options", "onChange"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userForm.weblink) = $event)),
                              type: "text",
                              id: "website",
                              name: "website",
                              placeholder: "https://example.com"
                            }, null, 512), [
                              [_vModelText, _ctx.userForm.weblink]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _hoisted_51,
                          _createElementVNode("div", _hoisted_52, [
                            _hoisted_53,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userForm.facebook) = $event)),
                              type: "text",
                              id: "facebook",
                              name: "facebook",
                              placeholder: "https://example-facebook.com"
                            }, null, 512), [
                              [_vModelText, _ctx.userForm.facebook]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, [
                            _hoisted_58,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userForm.twitter) = $event)),
                              type: "text",
                              id: "twitter",
                              name: "twitter",
                              placeholder: "https://example-twitter.com"
                            }, null, 512), [
                              [_vModelText, _ctx.userForm.twitter]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("div", _hoisted_62, [
                            _hoisted_63,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userForm.linkedin) = $event)),
                              type: "text",
                              id: "linkedin",
                              name: "linkedin",
                              placeholder: "https://example-linkedin.com"
                            }, null, 512), [
                              [_vModelText, _ctx.userForm.linkedin]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("div", _hoisted_67, [
                            _hoisted_68,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.userForm.pinterest) = $event)),
                              type: "text",
                              id: "pinterest",
                              name: "pinterest",
                              placeholder: "https://example-pinterest.com"
                            }, null, 512), [
                              [_vModelText, _ctx.userForm.pinterest]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createElementVNode("div", _hoisted_72, [
                            _hoisted_73,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.userForm.dribble) = $event)),
                              type: "text",
                              id: "dribble",
                              name: "dribble",
                              placeholder: "https://example-dribbble.com"
                            }, null, 512), [
                              [_vModelText, _ctx.userForm.dribble]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, [
                          _hoisted_76,
                          _createElementVNode("div", _hoisted_77, [
                            _hoisted_78,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.userForm.behance) = $event)),
                              type: "text",
                              id: "behance",
                              name: "behance",
                              placeholder: "https://example-behance.com"
                            }, null, 512), [
                              [_vModelText, _ctx.userForm.behance]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("div", _hoisted_82, [
                              _createElementVNode("div", _hoisted_83, [
                                _hoisted_84,
                                _createElementVNode("div", _hoisted_85, [
                                  _hoisted_86,
                                  _hoisted_87,
                                  _createElementVNode("input", {
                                    onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleLogoUpload && _ctx.handleLogoUpload(...args))),
                                    type: "file"
                                  }, null, 32)
                                ]),
                                _hoisted_88
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_89, [
                              _createElementVNode("div", _hoisted_90, [
                                _hoisted_91,
                                _createElementVNode("div", _hoisted_92, [
                                  _hoisted_93,
                                  _hoisted_94,
                                  _createElementVNode("input", {
                                    onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleCoverUpload && _ctx.handleCoverUpload(...args))),
                                    type: "file"
                                  }, null, 32)
                                ]),
                                _hoisted_95
                              ])
                            ])
                          ]),
                          (_ctx.userForm.logo || _ctx.userForm.cover_photo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                _createElementVNode("div", _hoisted_97, [
                                  (_ctx.logoVisible)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        width: "300",
                                        src: _ctx.userForm.logo
                                      }, null, 8, _hoisted_98))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("img", {
                                    src: _ctx.previewlogo,
                                    width: "200",
                                    alt: ""
                                  }, null, 8, _hoisted_99)
                                ]),
                                _createElementVNode("div", _hoisted_100, [
                                  (_ctx.coverlogoVisible)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        width: "300",
                                        src: _ctx.userForm.cover_photo
                                      }, null, 8, _hoisted_101))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("img", {
                                    src: _ctx.previewcoverlogo,
                                    width: "200",
                                    alt: ""
                                  }, null, 8, _hoisted_102)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("div", _hoisted_104, [
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.updateCompanyProfile && _ctx.updateCompanyProfile(...args))),
                                class: "primry-btn-2 lg-btn w-unset",
                                type: "button"
                              }, "Update Change"))
                            : (_openBlock(), _createElementBlock("button", _hoisted_105, _hoisted_108))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}